import { PropTypes } from "@l2r-front/l2r-proptypes"

export const report = PropTypes.shape({
    isClosed: PropTypes.bool,
    isClosedPrematurely: PropTypes.bool,
    reportSteps: PropTypes.arrayOf(PropTypes.string),
    uuid: PropTypes.string,
})